import { useQuery } from "@apollo/client";
import { Form, FormInstance, Select } from "antd";
import React, { FC } from "react";
import { PARENT_PHASES_QUERY } from "~/graphql/query/phase-select-query";

type Props = {
  form: FormInstance;
  parentMatterId: number;
};

export const ParentPhaseSelect: FC<Props> = ({ parentMatterId, form }) => {
  const { data, loading } = useQuery(PARENT_PHASES_QUERY, {
    variables: { findParentMatterId: parentMatterId },
  });

  const options: React.ComponentProps<typeof Select>["options"] =
    data?.findParentMatter?.phases.map((x) => ({
      value: x.id,
      label: x.title,
    }));

  return (
    <div>
      <Form form={form}>
        <Form.Item
          name="parentPhaseId"
          label="Phase"
          rules={[
            {
              required: true,
              message: "Select a Phase to add this proposal to",
            },
          ]}
        >
          <Select
            placeholder="Select a Phase to add this proposal to"
            loading={loading}
            options={options}
          ></Select>
        </Form.Item>
      </Form>
    </div>
  );
};
